import styled from '@emotion/styled';
import { Divider } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const ProductDivider = styled(Divider)`
  height: 4px !important;
  margin-top: 20px !important;
  margin-bottom: 8px !important;
  background-color: ${colors.gray100} !important;
  width: calc(100% + 24px) !important;
  margin-left: -12px !important;
`;

export const RefundPolicyContainer = styled.div`
  border-radius: 8px;
  background-color: ${colors.gray100};
  padding: 12px;
`;

export const FixedBottom = styled.div`
  position: fixed;
  bottom: 0px;
  transition: bottom 0.1s ease 0s;
  width: 100%;
  padding: 0 12px 20px;
  background-color: ${colors.white};
  z-index: 10;

  @media (min-width: 600px) {
    max-width: 450px;
  }
`;

export const GradientBox = styled.div`
  position: absolute;
  left: 0;
  bottom: 80px;
  width: 100%;
  height: 14px;
  background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
`;

export const ContainerContent = styled.div`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding-bottom: 0;

  @media screen {
    position: relative;
    margin: 0 auto;
    min-height: 100vh;

    @media (min-width: 600px) {
      max-width: 450px;
    }

    &:before {
      content: ' ';
      position: absolute;
      left: -1px;
      top: 0;
      bottom: 0;
      border-left: 1px solid #fff;
    }
  }
`;

export const FlickingWrapper = styled.div`
  position: relative;

  .flicking-viewport {
    overflow: hidden;
    height: 100%;
  }

  .flicking-camera {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    position: relative;
    margin-top: 50px;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  min-width: 100%;

  img {
    width: 100%;
    user-drag: none;
    user-select: none;
    -webkit-user-drag: none;
  }
`;

export const IndexPill = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  left: 17px;
  background-color: ${colors.blackOpacity400};
  backdrop-filter: blur(2px);
  border-radius: 100px;
  padding: 8px 12px;
  z-index: 9;
  width: fit-content;
  margin-bottom: 12px;
  margin-left: 12px;
`;

export const OrderViewConatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 20px;
  width: 100%;
  background-color: ${colors.blackOpacity300};
  backdrop-filter: blur(2px);
  z-index: 9;
  cursor: pointer;
  transition: 0.2s background;

  :hover {
    background-color: ${colors.blackOpacity200};
  }

  :active {
    background-color: ${colors.blackOpacity400};
  }
`;

export const PreviewGuideBox = styled.div`
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0px);
  bottom: 100px;
  border-radius: 10rem;
  background: rgba(21, 21, 21, 0.95);
  backdrop-filter: blur(2px);
  padding: 10px 20px;
  z-index: 9999;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 6px;
`;
